import myzxios from '../utils/myaxios'

    export function uploadDayFlowList(data) {
        return myzxios({
            url: '/manager/exportChargeList',
            data,
            method: 'post'
        })
    }



    export function getMonthUsedInfo(data) {
        return myzxios({
            url: '/manager/getMonthFlowList',
            data,
            method: 'post'
        })
    }

    export function queryPackageDescInfoActive(data) {
        return myzxios({
            url: '/manager/packet/queryPackageDescInfoActive',
            data,
            method: 'post'
        })
    }

    export function btAuth(data) {
        return myzxios({
            url: '/manager/bt-auth',
            params: data,
        })
    }

    export function queryflow(data) {
        return myzxios({
            url: '/manager/Jndx/queryflow',
            data,
            method: 'post'
        })
    }

    export function queryPaySign(data) {
        return myzxios({
            url: '/manager/queryPaySign/'+data,
        })
    }

    export function updateCardInfo(data) {
        return myzxios({
            url: '/manager/upd_info',
            data,
            method: "post"
        })
    }

    export function sa_bal(data) {
        return myzxios({
            url: '/manager/sa-bal',
            data,
            method: "post"
        })
    }

    export function gtPropress() {
        return myzxios({
            url: '/manager/gt-progress',
        })
    }

    export function exportExcel(data) {
        return myzxios({
            url: '/manager/exportExcel',
            data,
            method: "post"
        })
    }

    export function cancelCard(data) {
        return myzxios({
            url: '/manager/cancelCard/'+data,
        })
    }

    export function xkRestoreOperation(data) {
        return myzxios({
            url: '/manager/xkRestoreOperation/'+data,
        })
    }

    export function queryIotFlow(data) {
        return myzxios({
            url: '/manager/qu-iot-flow/' + data,
        })
    }

    export function changeStatus(data) {
        return myzxios({
            url: '/manager/change-TF',
            params: data
        })
    }

    export function queryIotAuth(data) {
        return myzxios({
            url: '/manager/qu-iot-auth/' + data,
        })
    }

    export function queryFlowInfo(data) {
        return myzxios({
            url: '/manager/qu-flow-info/' + data,
        })
    }

    export function queryFlowInfoAnlt(data) {
        return myzxios({
            url: '/manager/qu-flow-info-anlt/' + data,
        })
    }

    export function queryStatusInfo(data) {
        return myzxios({
            url: '/manager/qu-status-info/' + data,
        })
    }

    export function queryAUTH(data) {
        return myzxios({
            url: '/manager/qu-auth/' + data,
        })
    }

    export function queryHisFlowDesc(data) {
        return myzxios({
            url: '/manager/qu-his-flow-desc/' + data,
        })
    }

    export function find_classification(data) {
        return myzxios({
            url: '/manager/find_classification',
            data,
            method: "post"
        })
    }

    export function getFlowList(data) {
        return myzxios({
            url: '/manager/getFlowList',
            params: data,
        })
    }

    export function getCardList(data) {
        return myzxios({
            url: '/manager/getCardList',
            data,
            method: 'post'
        })
    }

    export function changeAuth(data) {
        return myzxios({
            url: '/manager/qu-changeAuth/'+data,
            method: 'put'
        })
    }

    export function getResourceList(data) {
        return myzxios({
            url: '/manager/getResourceList',
            params: data
        })
    }

    export function getBasicInfo(data) {
        return myzxios({
            url: '/manager/basicInfo/'+data,
        })
    }

    export function getDiagnosis(data) {
        return myzxios({
            url: '/manager/diagnosis/'+data,
        })
    }

    export function getCardOutList(data) {
        return myzxios({
            url: '/manager/cardOut/getCardOutList',
            data,
            method: 'post'
        })
    }

    export function exportExcelOut(data) {
        return myzxios({
            url: '/manager/cardOut/exportExcel',
            data,
            method: "post"
        })
    }

    export function getTestMessage(data) {
        return myzxios({
            url: '/manager/testMessage/getTestMessage',
            data,
            method: 'post'
        })
    }



